<template>
  <el-table-column
    prop="address.postal_code"
    label="Irányítószám"
    show-overflow-tooltip
    min-width="150"
    sortable="custom"
  >
    <template slot-scope="scope">
      <div v-if="scope.row.address && scope.row.address.postal_code" style="display: inline-block;">
        {{ scope.row.address.postal_code }}
      </div>
      <div v-else>-</div>
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'address.postal_code',
  };
</script>
